import { DataHeader } from '@acin/ui-core';
import { ISortDirection, ISortInput } from '../../graphql/generated';

export const TABLE_HEADERS: DataHeader[] = [
  { label: 'Regulation Name', key: 'title', width: '80%', sortable: true },
  { label: 'Status', key: 'status', minWidth: '20%', sortable: true },
];

export const mapToGraphqlSort = (field: string, direction: ISortDirection): ISortInput[] => [
  { field: `REGULATION_${field.toUpperCase()}`, direction },
  { field: 'REGULATION_ID', direction: ISortDirection.Asc }, // use as tie breaker to ensure consistent ordering
];
